import ccai from '../../assets/slide-2.svg'
import ccats from '../../assets/slide-1.svg'
import lms from '../../assets/slide-3.svg'
import slide4 from '../../assets/slide-4.svg'

import ccatsLogo from '../../assets/CC ATS Logo 1.svg'
import Ai from '../../assets/cc Ai.svg'
import SANlogo from '../../assets/SAN Technovation - Logo 1 3.avif'
import lmsLogo from '../../assets/lmsLogo.avif'
// import hrmsLogo from '../../assets/hrms-page.avif'
import hrmsLogo from '../../assets/hrmsLogo.avif'
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from 'react-router-dom'


export default function DigitalProduct() {
    const nav = useNavigate()
    return (
        <section className="py-2 px-4 sm:px-6 md:px-12 lg:px-24 bg-secondary-50">
            <div className="mx-auto max-w-7xl px-6">

                {/* TITLE */}
                <h2 className="font-bold text-2xl md:text-3xl lg:text-4xl mt-6">
                    Digital Products With Built-In Intelligence
                </h2>

                <p className="font-secondary text-black font-medium text-base md:text-lg lg:text-xl leading-relaxed py-4 max-w-5xl">
                    Intelligent platforms designed to solve real business challenges, built for scale,
                    reliability, and long-term value.
                </p>

                {/* ===================================================== */}
                {/* MOBILE + TABLET VERSION (CLEAN & USABLE) */}
                {/* ===================================================== */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:hidden mt-6">

                    {[
                        { img: ccats, logo: Ai, title: "CareerConnect AI", size: '100px' },
                        { img: ccai, logo: ccatsLogo, title: "CareerConnect ATS", size: '130px' },
                        { img: lms, logo: lmsLogo, title: "SAN LMS", size: '170px' },
                        { img: slide4, logo: hrmsLogo, title: "SAN HRMS", size: '190px' },
                    ].map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl p-4 shadow-sm"
                        >
                            <div className="mt-4 text-center">
                                <img
                                    src={item.logo}
                                    alt={item.title}
                                    style={{ width: item.size }}
                                    className={`  mx-auto  object-contain`} />

                                <h4 className="font-semibold text-lg text-center mt-3">
                                    {item.title}
                                </h4>
                            </div>

                            <button
                                onClick={() => nav('/product')}
                                className="mt-4 mx-auto flex text-secondary-500 font-semibold text-sm items-center gap-2">
                                Learn More <FiArrowRight />
                            </button>
                        </div>

                    ))}

                </div>


                <div className="hidden lg:block relative mt-10">

                    <div className="relative">

                        {/* TOP ROW */}
                        <div className="flex justify-around gap-4">

                            {/* ===== CARD 1 ===== */}
                            <div className="relative inline-block group">

                                <img
                                    src={ccats}
                                    alt="CCAI"
                                    className="transition-opacity duration-300 group-hover:opacity-0"
                                />

                                <div
                                    className="absolute inset-0 bg-secondary-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                    style={{
                                        WebkitMaskImage: `url(${ccats})`,
                                        WebkitMaskRepeat: "no-repeat",
                                        WebkitMaskSize: "100% 100%",
                                        WebkitMaskPosition: "center",
                                        maskImage: `url(${ccats})`,
                                        maskRepeat: "no-repeat",
                                        maskSize: "100% 100%",
                                        maskPosition: "center",
                                    }}
                                />

                                <img
                                    src={Ai}
                                    alt="CC AI Logo"
                                    className="absolute 2xl:w-auto 2xl:h-auto w-[240px] top-[66px] 2xl:top-14 left-28 transition-opacity duration-300 group-hover:opacity-0 pointer-events-none"
                                />

                                <p className="font-medium text-xl absolute bottom-12 2xl:bottom-20  left-[150px] 2xl:left-[200px] transition-opacity duration-300 group-hover:opacity-0 pointer-events-none">
                                    CareerConnect Ai
                                </p>

                                <div
                                    onClick={() => nav('/product/ccai')}
                                    className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100 cursor-pointer">
                                    <span className="text-white text-lg font-medium flex items-center gap-2">
                                        Learn More <FiArrowRight />
                                    </span>
                                </div>

                            </div>

                            {/* ===== CARD 2 ===== */}
                            <div className="relative inline-block group">

                                <img
                                    src={ccai}
                                    alt="CCATS"
                                    className="transition-opacity duration-300 group-hover:opacity-0 "
                                />

                                <div
                                    className="absolute inset-0 bg-secondary-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                    style={{
                                        WebkitMaskImage: `url(${ccai})`,
                                        WebkitMaskRepeat: "no-repeat",
                                        WebkitMaskSize: "100% 100%",
                                        WebkitMaskPosition: "center",
                                        maskImage: `url(${ccai})`,
                                        maskRepeat: "no-repeat",
                                        maskSize: "100% 100%",
                                        maskPosition: "center",
                                    }}
                                />

                                <img
                                    src={ccatsLogo}
                                    alt="CC ATS Logo"
                                    className="absolute 2xl:w-auto 2xl:h-auto w-[300px] top-14 left-28 transition-opacity duration-300 group-hover:opacity-0 pointer-events-none"
                                />

                                <p className="font-medium text-xl absolute bottom-12 2xl:bottom-20 left-[170px] 2xl:left-[200px] transition-opacity duration-300 group-hover:opacity-0 pointer-events-none">
                                    CareerConnect ATS
                                </p>

                                <div
                                    onClick={() => nav('/product/ccai-ats')}
                                    className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100 cursor-pointer">
                                    <span className="text-white text-lg font-medium flex items-center gap-2">
                                        Learn More <FiArrowRight />
                                    </span>
                                </div>

                            </div>
                        </div>

                        {/* BOTTOM ROW */}
                        <div className="flex justify-around gap-4">

                            {[{ img: lms, logo: lmsLogo, title: "SAN LMS" },
                            { img: slide4, logo: hrmsLogo, title: "SAN HRMS" },].map((img, i) => (
                                <div key={i} className="relative inline-block group my-5">

                                    <img
                                        src={img.img}
                                        alt={img.title}
                                        className="transition-opacity duration-300 group-hover:opacity-0 "
                                    />

                                    <div
                                        className="absolute inset-0 bg-secondary-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                        style={{
                                            WebkitMaskImage: `url(${img.img})`,
                                            WebkitMaskRepeat: "no-repeat",
                                            WebkitMaskSize: "100% 100%",
                                            WebkitMaskPosition: "center",
                                            maskImage: `url(${img.img})`,
                                            maskRepeat: "no-repeat",
                                            maskSize: "100% 100%",
                                            maskPosition: "center",
                                        }}
                                    />

                                    <img
                                        src={img.logo}
                                        alt="SAN Logo"
                                        className={`absolute  w-[80%]  ${i === 0 ? "2xl:w-[80%] 2xl:h-auto top-4 left-10" : "2xl:w-[80%]  top-5 2xl:h-auto left-16"} transition-opacity duration-300 group-hover:opacity-0 pointer-events-none`}
                                    />

                                    <p className={`font-medium text-xl absolute bottom-10 2xl:bottom-11 ${i === 0 ? "2xl:left-[220px] left-[200px] " : "2xl:left-[250px] left-[230px]"} transition-opacity duration-300 group-hover:opacity-0 pointer-events-none`}>
                                        {img.title}
                                    </p>

                                    <div
                                        onClick={() => nav(img.title === "SAN LMS" ? '/product/lms' : '/product/hrms')}
                                        className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100 cursor-pointer">
                                        <span className="text-white text-lg font-medium flex items-center gap-2">
                                            Learn More <FiArrowRight />
                                        </span>
                                    </div>

                                </div>
                            ))}

                        </div>

                        {/* CENTER CIRCLE */}
                        <div className="absolute top-[240px] 2xl:top-[270px] lg:right-[42.2%]">
                            <div className=" lg:w-[161px] lg:h-[161px] 2xl:w-[191px] 2xl:h-[191px] bg-white rounded-full relative hover:shadow-[0_0_60px_rgba(0,0,0,0.25)] hover:shadow-secondary-500 transition-shadow duration-300">
                                <img
                                    src={SANlogo}
                                    alt="SANLogo"
                                    className="lg:w-[90px] lg:h-[110px] 2xl:w-[119px] 2xl:h-[151px] absolute lg:top-7 lg:left-8 2xl:top-6 2xl:left-9"
                                />
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
}


